module.exports = __webpack_public_path__ + "static/media/fig_11b.f5824ed5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_11b.gif
// module id = 629
// module chunks = 0